'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyIdTransform = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _indexedDataInvariant = require('../invariants/indexedDataInvariant');

var _getters = require('./getters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Transform an id into a key for IndexedAsyncData
 *
 * @param {Any} id an id that passes the id invariant
 * @param {IndexedAsyncData} indexedData IndexedAsyncData to get the entry in
 * @returns {Any} key
 */
var applyIdTransform = exports.applyIdTransform = (0, _curry2.default)(function (id, indexedData) {
  (0, _indexedDataInvariant.indexedDataInvariant)(indexedData);

  var idTransform = (0, _getters.getIdTransform)(indexedData);
  return idTransform(id);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/indexed-async-data/operators/applyIdTransform.js
// module id = 181
// module chunks = 2 3